module.exports = __webpack_public_path__ + "img/icon-admin.8fe14426.svg";